import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import AlmigButton from "../grundelemente/AlmigButton";
import InfoBlock from "../grundelemente/InfoBlock";
import InfoDateContainer from "../grundelemente/InfoDateContainer";
import InfoEmpty from "../grundelemente/InfoEmpty";
import InfoPanel from "../grundelemente/InfoPanel";
import "./GrafikenInfoPanel.css";

const GrafikenInfoPanel = props => (
	<InfoPanel className="GrafikenInfoPanel">
		<InfoBlock>
			<AlmigButton i18n_key="Print preview"
				onClick={() => props.printRequest()}/>
		</InfoBlock>
		<InfoEmpty height="200px" />
		<InfoBlock>
			<Button className={classNames("StatusToggle",
				props.show_compressor_state ? "Active" : "Inactive")}
			onClick={() => {
				props.setShowCompressorState(!props.show_compressor_state);
			}}>
				<div className="StatusGrid">
					<div className="StatusStatus">
						<FormattedMessage id="State"/>
					</div>
					<div className="StatusFarbe Lastlauf" />
					<FormattedMessage id="Load" />
					<div className="StatusFarbe Leerlauf" />
					<FormattedMessage id="No-load" />
					<div className="StatusFarbe Aus" />
					<FormattedMessage id="Off" />
					<div className="StatusFarbe Störung" />
					<FormattedMessage id="Error" />
					<div className="StatusFarbe KeineDaten" />
					<FormattedMessage id="No Data" />
				</div>
			</Button>
		</InfoBlock>
		<InfoDateContainer />
	</InfoPanel>
);

GrafikenInfoPanel.propTypes = {
	show_compressor_state: PropTypes.bool.isRequired,
	setShowCompressorState: PropTypes.func.isRequired,
	printRequest: PropTypes.func.isRequired
};

export default GrafikenInfoPanel;
